import { useNavigate } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'
import { Layout } from '@/modules/shared/layouts/layout'

import { SearchFormReportPeriod } from '../search-form-report-period.component'
import { ChartSalesByProductReport } from './chart-sales-by-product'
import ListSalesByProductReport from './list-sales-by-product'

export function ReportSalesByProduct() {
  const navigate = useNavigate()

  const { loading, jsonSalesByProduct } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesByProduct: state.jsonSalesByProduct,
    }),
    shallow,
  )

  const handleBackPage = () => {
    navigate('/relatorios')
  }

  return (
    <Layout hasSellerFilter
      pageTitle="Relatório - Vendas x Produtos"
      handleGoBack={handleBackPage}
    >
      <SearchFormReportPeriod reportType="Product" />

      {!loading && !!jsonSalesByProduct && (
        <div className="mt-2 space-y-2">
          <ChartSalesByProductReport />

          <ListSalesByProductReport />
        </div>
      )}
    </Layout>
  )
}
